import { render } from "./Sidebar.vue?vue&type=template&id=0383c81e"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=0383c81e&lang=scss"
script.render = render

export default script